export default __webpack_public_path__ + "static/media/mike.f9e65d20.jpg";